module.exports = __webpack_public_path__ + "img/wall_items-sprite-2x.d88de300.png";